<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    :close-on-content-click="false"
    max-width="1600"
    :key="dialogKey"
  >
    <div class="detalhes-agendamento-modal">
      <div class="modal-header">
        <div class="header-content">
          <div class="header-left">
            <div class="header-icon">
              <v-icon>mdi-account-multiple</v-icon>
            </div>
            <div class="header-text">
              <h2 class="header-title">Detalhes do Agendamento Coletivo</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="unified-content">
        <v-card class="unified-card">
          <div class="form-content">
            <v-row class="mb-4" align="center" justify="center">
              <v-col cols="12" md="4" class="text-center">
                <span class="font-weight-bold">Data:</span>
                <span class="ml-1">{{ dataFormatada }}</span>
              </v-col>
              <v-col cols="12" md="4" class="text-center">
                <span class="font-weight-bold">Horário:</span>
                <span class="ml-1">{{ horario }}</span>
              </v-col>
              <v-col cols="12" md="4" class="text-center" v-if="duracaoFormatada">
                <span class="font-weight-bold">Duração:</span>
                <span class="ml-1">{{ duracaoFormatada }}</span>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="linhas"
              class="elevation-0"
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item.confirmado="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-icon :color="item.agendamentoConfirmado ? 'green' : 'orange'">
                        {{ item.agendamentoConfirmado ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                      </v-icon>
                    </span>
                  </template>
                  <span>
                    {{ item.agendamentoConfirmado ? 'Agendamento confirmado' : 'Agendamento não confirmado' }}
                  </span>
                </v-tooltip>
              </template>
              <template v-slot:item.status="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" :style="{ cursor: isCancelado(item.original) ? 'default' : 'pointer', display: 'inline-flex', 'align-items': 'center' }">
                      <span @click.stop="isCancelado(item.original) ? null : handleAlterarStatus(item.original, nextStatus(item.original))" style="display:inline-flex; align-items:center;">
                        <v-icon :color="getStatusMeta(item.original.situacaoAgendamento).color" small class="mr-2">
                          {{ getStatusMeta(item.original.situacaoAgendamento).icon }}
                        </v-icon>
                        <span>{{ formatarStatus(item.original.situacaoAgendamento) }}</span>
                      </span>
                    </span>
                  </template>
                  <span>{{ getTooltipStatus(item.original) }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.acoes="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-icon
                        :class="{ 'icon-disabled': item.agendamentoConfirmado }"
                        :color="item.agendamentoConfirmado ? 'grey' : 'green'"
                        @click="item.agendamentoConfirmado ? null : $emit('whatsapp', item.original)"
                      >
                        mdi-whatsapp
                      </v-icon>
                    </span>
                  </template>
                  <span>
                    {{ item.agendamentoConfirmado ? 'Agendamento já confirmado' : 'Enviar link de confirmação' }}
                  </span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="mx-2">
                      <v-icon
                        :class="{ 'icon-disabled': !item.temObservacoes }"
                        :color="item.temObservacoes ? '#5c6bc0' : 'grey'"
                        @click="item.temObservacoes ? $emit('ver-observacoes', item.original) : null"
                      >
                        mdi-eye
                      </v-icon>
                    </span>
                  </template>
                  <span>
                    {{ item.temObservacoes ? 'Ver observações' : 'Sem observações' }}
                  </span>
                </v-tooltip>

                <v-tooltip bottom v-if="isCancelado(item.original)">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="mx-2">
                      <v-icon color="#424242" @click="verMotivoCancelamento(item.original)">
                        mdi-comment-text-multiple-outline
                      </v-icon>
                    </span>
                  </template>
                  <span>Ver motivo do cancelamento</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-icon
                        :class="{ 'icon-disabled': isCancelado(item.original) }"
                        :color="isCancelado(item.original) ? 'grey' : '#1976d2'"
                        @click="isCancelado(item.original) ? null : $emit('editar', item.original.id)">
                        mdi-pencil
                      </v-icon>
                    </span>
                  </template>
                  <span>{{ isCancelado(item.original) ? 'Não é possível editar agendamento cancelado' : 'Editar agendamento' }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="ml-2">
                      <v-icon
                        :class="{ 'icon-disabled': !isCancelado(item.original) }"
                        :color="isCancelado(item.original) ? 'red' : 'grey'"
                        @click="isCancelado(item.original) ? $emit('excluir', item.original) : null"
                      >
                        mdi-delete
                      </v-icon>
                    </span>
                  </template>
                  <span>
                    {{ isCancelado(item.original)
                      ? 'Excluir agendamento individual'
                      : 'Disponível apenas quando o status estiver como Cancelado' }}
                  </span>
                </v-tooltip>
                <div v-if="isCancelado(item.original) && (item.motivoCancelamento
                || item.original?.motivoCancelamentoAgendamento || item.original?.agendamentoConsulta?.motivoCancelamentoAgendamento)" class="motivo-cancelamento-wrapper">
                  <span class="motivo-label">Motivo:</span>
                  <span class="motivo-text-acoes">{{ item.motivoCancelamento
                  || item.original?.motivoCancelamentoAgendamento || item.original?.agendamentoConsulta?.motivoCancelamentoAgendamento }}</span>
                </div>
              </template>
            </v-data-table>
            <!-- instância única do modal de atualização de situação (uso compartilhado para a modal de cancelamento) -->
            <AtualizaSituacaoAgendamento
              ref="atualizaSituacao"
              :situacao="cancelModalSituacao"
              :tipoAgendamento="cancelModalTipoAgendamento"
              :agendamentoId="cancelModalAgendamentoId"
              :hideActivator="true"
              @clickSituacaoAgendamento="onAtualizaSituacao"
            />
          </div>
          <div class="form-actions">
            <div class="actions-container">
              <v-btn class="action-btn cancel-btn" @click="$emit('input', false)">
                <v-icon left>mdi-keyboard-return</v-icon>
                Cancelar
              </v-btn>
              <v-btn class="action-btn edit-btn" @click="emitirAdicionarPaciente">
                <v-icon left>mdi-account-plus</v-icon>
                Adicionar Paciente neste agendamento
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import { AlertaSimplesErro, AlertaPerguntaSimOuNaoBooleano } from '@/helpers/MensagemHelper';
import { AgendamentoService } from '@/services/AgendamentoService';
import { ConvenioService } from '@/services/ConveioService';
import moment from 'moment';
import DateHelper from '../../helpers/DateHelper';
import AtualizaSituacaoAgendamento from '@/components/agendamento/AtualizaSituacaoAgendamento.vue';

export default Vue.extend({
  name: 'ModalVisualizarAgendamentoColetivo',
  components: {
    AtualizaSituacaoAgendamento,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    agendamentos: {
      type: Array,
      required: true,
    },
    dataAgendamento: {
      type: String,
      default: '',
    },
    horario: {
      type: String,
      default: '',
    },
    dialogKey: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      localAgendamentos: Array.isArray(this.agendamentos)
        ? this.agendamentos.map((a) => (typeof a === 'object' && a !== null ? { ...a } : {}))
        : [],
      agendamentoService: new AgendamentoService(),
      convenioService: new ConvenioService(),
      convenioCache: {} as Record<number | string, string>,
      pendingCancelamento: null as null | { id: number; agendamento: any },
      cancelModalSituacao: '',
      cancelModalTipoAgendamento: '',
      cancelModalAgendamentoId: null as number | null,
    };
  },
  computed: {
    dataFormatada(): string {
      const primeiraLinha = (this.agendamentos || [])[0] || {};
      const origem = this.dataAgendamento
        || primeiraLinha?.dataAgendamento
        || primeiraLinha?.agendamentoConsulta?.dataAgendamento
        || primeiraLinha?.start
        || '';

      if (!origem) {
        return '';
      }

      const data = origem.trim();
      const dataExtenso = moment(data, 'dddd, D [de] MMMM [de] YYYY', 'pt-br', true);
      if (dataExtenso.isValid()) {
        return dataExtenso.format('DD/MM/YYYY');
      }
      const dataBrRegex = /^\d{2}\/\d{2}\/\d{4}$/;
      if (dataBrRegex.test(data)) {
        return data;
      }

      const dataIsoRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (dataIsoRegex.test(data)) {
        return DateHelper.formataParaDiaMesAno(data);
      }

      if (data.includes('T')) {
        return DateHelper.formataParaDiaMesAno(data.split('T')[0]);
      }

      if (data.includes(' ')) {
        return DateHelper.formataParaDiaMesAno(data.split(' ')[0]);
      }

      try {
        return DateHelper.formatoBR(data);
      } catch (error) {
        return '';
      }
    },
    duracaoFormatada(): string {
      const primeiraLinha = (this.agendamentos || [])[0] || {};
      const start = primeiraLinha?.start || primeiraLinha?.dataInicio || '';
      const end = primeiraLinha?.end || primeiraLinha?.dataFim || '';

      if (start && end) {
        const inicio = moment(start);
        const fim = moment(end);
        if (inicio.isValid() && fim.isValid()) {
          const diffMinutes = Math.max(0, fim.diff(inicio, 'minutes'));
          const horas = Math.floor(diffMinutes / 60);
          const minutos = diffMinutes % 60;
          return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`;
        }
      }

      const duracao = primeiraLinha?.duracao || primeiraLinha?.duracaoAgendamento;
      if (duracao) {
        return duracao;
      }

      return '';
    },
    headers() {
      return [
        { text: 'Paciente', value: 'paciente' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'Convênio', value: 'convenio' },
        { text: 'Status', value: 'status' },
        { text: 'Tipo de consulta', value: 'tipoConsulta' },
        { text: 'Confirmado', value: 'confirmado', align: 'center' },
        {
          text: 'Ações',
          value: 'acoes',
          align: 'center',
          sortable: false,
        },
        { text: 'Agendado por', value: 'agendadoPor' },
      ];
    },
    linhas() {
      return (this.localAgendamentos || []).map((agendamento: any) => {
        const paciente = agendamento.paciente || agendamento.agendamentoConsulta?.paciente;
        let nomePaciente = '-';
        if (paciente) {
          nomePaciente = paciente.usarNomeSocialComoPrincipal ? paciente.nomeSocial : paciente.nomeCompleto;
        }

        const telefone = agendamento.agendamentoConsulta?.telefone
          || paciente?.contato?.telefonePrincipal
          || paciente?.telefonePrincipal
          || '-';

        const convenio = this.obterNomeConvenio(agendamento);

        const status = this.formatarStatus(agendamento.situacaoAgendamento);

        const motivoCancelamento = agendamento.motivoCancelamentoAgendamento
          || agendamento.motivoCancelamento
          || (agendamento.agendamentoConsulta && agendamento.agendamentoConsulta.motivoCancelamentoAgendamento)
          || '';

        const tipoConsulta = agendamento.nomeTipoConsulta
          || agendamento.tipoConsulta?.descricao
          || agendamento.tipoConsultaDescricao
          || 'Não informado';

        const agendadoPor = agendamento.usuario?.nomeCompleto
          || agendamento.usuarioNome
          || '-';

        const temObservacoes = !!(
          agendamento.observacao
          || agendamento.observacaoAgendamento
          || agendamento.orientacoesPaciente
          || (agendamento.agendamentoConsulta && (
            agendamento.agendamentoConsulta.observacao
            || agendamento.agendamentoConsulta.orientacoesPaciente
          ))
        );

        return {
          id: agendamento.id,
          paciente: nomePaciente,
          telefone,
          convenio,
          status,
          tipoConsulta,
          agendamentoConfirmado: !!agendamento.agendamentoConfirmado,
          temObservacoes,
          motivoCancelamento,
          agendadoPor,
          original: agendamento,
        };
      });
    },
  },
  watch: {
    agendamentos: {
      handler(newVal) {
        if (!newVal) return;
        this.localAgendamentos = newVal.map((a: any) => ({ ...a }));
        this.carregarTodosConvenios(newVal);
      },
      immediate: true,
    },
  },
  methods: {
    formatarStatus(status: any) {
      if (status === null || status === undefined || status === '') {
        return 'Marcado';
      }

      if (typeof status === 'number') {
        return ['Marcado', 'Em Espera', 'Em Andamento', 'Faltou', 'Finalizado', 'Cancelado'][status] || 'Marcado';
      }

      if (typeof status === 'string') {
        return status
          .replace('EmEspera', 'Em Espera')
          .replace('EmAndamento', 'Em Andamento');
      }

      return 'Marcado';
    },
    isCancelado(agendamento) {
      const situacao = agendamento?.situacaoAgendamento;
      if (typeof situacao === 'string') {
        return situacao.toLowerCase() === 'cancelado';
      }
      return situacao === 5;
    },
    hasMotivoCancelamento(agendamento: any) {
      if (!agendamento) return false;
      return !!(
        agendamento.motivoCancelamentoAgendamento
        || agendamento.motivoCancelamento
        || (agendamento.agendamentoConsulta && agendamento.agendamentoConsulta.motivoCancelamentoAgendamento)
      );
    },
    getTooltipStatus(agendamento: any) {
      if (this.isCancelado(agendamento)) {
        return 'O agendamento foi cancelado e, por isso, não pode ser editado. Caso queira verificar o motivo do cancelamento, clique no ícone de visualização para conferir os detalhes.';
      }
      const statuses = ['Marcado', 'Em Espera', 'Em Andamento', 'Faltou', 'Finalizado', 'Cancelado'];
      const proximo = this.nextStatus(agendamento);
      const situacaoFormatada = statuses[proximo] || 'Marcado';
      return `Clique para alterar a situação para: ${situacaoFormatada}`;
    },
    nextStatus(agendamento: any) {
      const statuses = ['Marcado', 'Em Espera', 'Em Andamento', 'Faltou', 'Finalizado', 'Cancelado'];
      const atual = agendamento?.situacaoAgendamento;
      if (typeof atual === 'number') {
        return (atual + 1) % statuses.length;
      }
      if (typeof atual === 'string') {
        const normalizado = atual.replace(/\s+/g, '').toLowerCase();
        const idx = statuses.findIndex((s) => s.replace(/\s+/g, '').toLowerCase() === normalizado);
        const base = idx >= 0 ? idx : 0;
        return (base + 1) % statuses.length;
      }
      return 0;
    },
    getStatusMeta(status: any) {
      const mapping = [
        { icon: 'mdi-calendar-check', color: '#84b6f4' },
        { icon: 'mdi-clock-alert-outline', color: '#77dd77' },
        { icon: 'mdi-progress-check', color: '#ffda9e' },
        { icon: 'mdi-close-octagon-outline', color: '#ff6961' },
        { icon: 'mdi-check-circle-outline', color: '#c5c6c8' },
        { icon: 'mdi-cancel', color: '#ffe180' },
      ];

      if (status === null || status === undefined || status === '') {
        return mapping[0];
      }

      if (typeof status === 'number') {
        return mapping[status] || mapping[0];
      }

      if (typeof status === 'string') {
        const normalizado = status.replace(/\s+/g, '').toLowerCase();
        const idx = mapping.findIndex((m, i) => {
          const text = ['Marcado', 'Em Espera', 'Em Andamento', 'Faltou', 'Finalizado', 'Cancelado'][i];
          return text.replace(/\s+/g, '').toLowerCase() === normalizado;
        });
        return mapping[idx >= 0 ? idx : 0];
      }

      return mapping[0];
    },
    async handleAlterarStatus(agendamento: any, novoStatus: number) {
      const id = agendamento?.id;
      if (!id && id !== 0) return;

      if (novoStatus === 5) {
        const confirmar = await AlertaPerguntaSimOuNaoBooleano(
          'Deseja cancelar?',
          'Ao cancelar o agendamento, será necessário informar o motivo. Deseja continuar?',
        );

        if (!confirmar) return;

        this.pendingCancelamento = { id, agendamento };
        const situacaoAtual = agendamento.situacaoAgendamento;
        const situacaoMap = ['Marcado', 'EmEspera', 'EmAndamento', 'Faltou', 'Finalizado', 'Cancelado'];
        if (typeof situacaoAtual === 'number') {
          this.cancelModalSituacao = situacaoMap[situacaoAtual] || 'Marcado';
        } else if (typeof situacaoAtual === 'string') {
          this.cancelModalSituacao = situacaoAtual.replace(/\s+/g, '') || 'Marcado';
        } else {
          this.cancelModalSituacao = 'Marcado';
        }
        this.cancelModalTipoAgendamento = (agendamento.agendamentoConsulta ? 'Consulta' : 'Compromisso');
        this.cancelModalAgendamentoId = id;

        this.$nextTick(() => {
          const child = (this.$refs.atualizaSituacao as any) || null;
          if (child) {
            try {
              child.confirmaCancelamentoAgendamento = true;
            } catch (e) {
              this.pendingCancelamento = null;
            }
          } else {
            this.pendingCancelamento = null;
          }
        });
        return;
      }

      const idx = this.localAgendamentos.findIndex((a: any) => a.id === id);
      const anterior = idx >= 0 ? { ...this.localAgendamentos[idx] } : null;
      if (idx >= 0) {
        this.$set(this.localAgendamentos, idx, {
          ...this.localAgendamentos[idx],
          situacaoAgendamento: novoStatus,
        });
      }
      try {
        await this.agendamentoService.atualizaSituacaoAgendamento(id, novoStatus as any);
        if (novoStatus === 1) {
          this.$emit('enviar-sala-espera', agendamento);
        }
        this.$emit('status-atualizado', id, novoStatus);
      } catch (err) {
        if (idx >= 0 && anterior) {
          this.$set(this.localAgendamentos, idx, anterior);
        }
        let mensagem = 'Erro ao alterar situação do agendamento.';
        if (err?.response?.data) {
          if (typeof err.response.data === 'string') mensagem = err.response.data;
          else if (err.response.data.Mensagem) mensagem = err.response.data.Mensagem;
          else if (err.response.data.message) mensagem = err.response.data.message;
        }
        AlertaSimplesErro('Erro ao alterar situação', mensagem);
      }
    },
    verMotivoCancelamento(agendamento: any) {
      const id = agendamento?.id;
      if (!id && id !== 0) return;

      const situacaoMap = ['Marcado', 'EmEspera', 'EmAndamento', 'Faltou', 'Finalizado', 'Cancelado'];
      const situacaoAtual = agendamento.situacaoAgendamento;
      if (typeof situacaoAtual === 'number') {
        this.cancelModalSituacao = situacaoMap[situacaoAtual] || 'Marcado';
      } else if (typeof situacaoAtual === 'string') {
        this.cancelModalSituacao = situacaoAtual.replace(/\s+/g, '') || 'Marcado';
      } else {
        this.cancelModalSituacao = 'Marcado';
      }

      this.cancelModalTipoAgendamento = (agendamento.agendamentoConsulta ? 'Consulta' : 'Compromisso');
      this.cancelModalAgendamentoId = id;

      this.$nextTick(() => {
        const child = (this.$refs.atualizaSituacao as any) || null;
        if (child && typeof child.clickIconVisualizacao === 'function') {
          try {
            child.clickIconVisualizacao();
          } catch (e) {
            // fallback: try to open dialog directly
            try { child.confirmaCancelamentoAgendamento = true; child.visualizarMotivoCancelamento = true; } catch (_) {
              // Handle error or log it if necessary
              console.error('Error while setting modal properties:', _);
            }
          }
        }
      });
    },
    emitirAdicionarPaciente() {
      const primeiro = (this.agendamentos || [])[0] || {};
      const dataOrigem = primeiro?.dataAgendamento || this.dataAgendamento || '';
      const dataAgendamento = this.normalizarDataParaIso(dataOrigem);
      const horaAgendamento = primeiro?.horaAgendamento || this.horario || '';
      const pacientesIds = (this.agendamentos || [])
        .map((agendamento: any) => agendamento?.agendamentoConsulta?.pacienteId
          || agendamento?.paciente?.id
          || agendamento?.pacienteId
          || 0)
        .map((id: any) => `${id}`)
        .filter((id: string) => id && id !== '0' && id !== 'null' && id !== 'undefined');

      this.$emit('adicionar-paciente', {
        dataAgendamento,
        horaAgendamento,
        pacientesIds,
      });
    },
    async onAtualizaSituacao(payload: any) {
      const id = payload?.agendamentoId || this.pendingCancelamento?.id;
      const motivo = payload?.motivoCancelamento || '';
      if (!id) return;

      const idx = this.localAgendamentos.findIndex((a: any) => a.id === id);
      const anterior = idx >= 0 ? { ...this.localAgendamentos[idx] } : null;

      if (idx >= 0) {
        this.$set(this.localAgendamentos, idx, {
          ...this.localAgendamentos[idx],
          situacaoAgendamento: 5,
        });
      }

      try {
        await this.agendamentoService.atualizaSituacaoAgendamento(id, 5 as any);
        if (motivo) {
          await this.agendamentoService.atualizaMotivoCancelamento(id, motivo);
        }
        this.$emit('status-atualizado', id, 5);
      } catch (err) {
        if (idx >= 0 && anterior) this.$set(this.localAgendamentos, idx, anterior);
        let mensagem = 'Erro ao alterar situação do agendamento.';
        if (err?.response?.data) {
          if (typeof err.response.data === 'string') mensagem = err.response.data;
          else if (err.response.data.Mensagem) mensagem = err.response.data.Mensagem;
          else if (err.response.data.message) mensagem = err.response.data.message;
        }
        AlertaSimplesErro('Erro ao alterar situação', mensagem);
      } finally {
        this.pendingCancelamento = null;
      }
    },
    normalizarDataParaIso(valor: string) {
      if (!valor) {
        return '';
      }

      const data = valor.trim();
      const dataExtenso = moment(data, 'dddd, D [de] MMMM [de] YYYY', 'pt-br', true);
      if (dataExtenso.isValid()) {
        return dataExtenso.format('YYYY-MM-DD');
      }

      if (data.includes('T')) {
        return data.split('T')[0];
      }

      if (data.includes(' ')) {
        return data.split(' ')[0];
      }

      const dataBrRegex = /^\d{2}\/\d{2}\/\d{4}$/;
      if (dataBrRegex.test(data)) {
        return DateHelper.formataParaAnoMesDia(data);
      }

      return data;
    },
    obterConvenioInfo(agendamento: any): { convenioId?: number | string; convenioNome?: string } {
      const convenioId = agendamento?.convenioId
        || agendamento?.agendamentoConsulta?.convenioId
        || agendamento?.agendamentoConsulta?.convenio?.id
        || agendamento?.convenio?.id;

      const convenioNome = agendamento?.agendamentoConsulta?.convenio?.nome
        || agendamento?.convenio?.nome
        || agendamento?.convenioNome;

      return { convenioId, convenioNome };
    },
    obterNomeConvenio(agendamento: any): string {
      const { convenioId, convenioNome } = this.obterConvenioInfo(agendamento);

      if (convenioId && this.convenioCache[convenioId]) {
        return this.convenioCache[convenioId];
      }

      if (convenioNome) {
        return convenioNome;
      }

      return 'Particular';
    },
    async carregarConvenio(convenioId: number | string): Promise<void> {
      if (!convenioId || this.convenioCache[convenioId]) {
        return;
      }

      try {
        const response = await (this.convenioService as any).Get(convenioId);
        const convenio = response?.data || response;
        if (convenio && convenio.nome) {
          this.$set(this.convenioCache, convenioId, convenio.nome);
        }
      } catch (error) {
        console.error(`Erro ao carregar convênio ${convenioId}:`, error);
      }
    },
    async carregarTodosConvenios(agendamentos: any[]): Promise<void> {
      if (!agendamentos || agendamentos.length === 0) {
        return;
      }

      const convenioIds = Array.from(new Set(
        (agendamentos || [])
          .map((agendamento: any) => this.obterConvenioInfo(agendamento).convenioId)
          .filter(Boolean),
      ));

      await Promise.all(convenioIds.map((convenioId) => this.carregarConvenio(convenioId as number | string)));
    },
  },
});
</script>

<style scoped>
.icon-disabled {
  opacity: 0.4;
  pointer-events: none;
}

/* === MODAL DETALHES DO AGENDAMENTO === */
.detalhes-agendamento-modal {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* === HEADER COMUM === */
.modal-header {
  background: var(--especialidade-primary, #2e4b9d);
  color: white;
  padding: 24px 32px;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  color: white;
}

/* === CONTEÚDO UNIFICADO === */
.unified-content {
  padding: 32px;
}

.unified-card {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
  max-width: 1500px;
  min-width: 1100px;
}

.form-content {
  padding: 24px;
}

.motivo-text {
  font-size: 12px;
  color: #616161;
  margin-top: 2px;
}

.motivo-cancelamento-wrapper {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding: 8px;
  background-color: #fff3cd;
  border-left: 3px solid #ffc107;
  border-radius: 4px;
}

.motivo-label {
  font-size: 11px;
  font-weight: 600;
  color: #856404;
  margin-bottom: 4px;
}

.motivo-text-acoes {
  font-size: 12px;
  color: #856404;
  line-height: 1.4;
}

/* === AÇÕES === */
.form-actions {
  padding: 24px 32px;
  background: #f8f9fa;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.actions-container {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.action-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 0 24px !important;
  height: 48px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
}

.action-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
}

.cancel-btn {
  background: #dc3545  !important;
  color: white !important;
}
</style>
